<template>
  <el-container class="layout-container">
    <columns-aside />
    <div class="layout-columns-warp">
      <layout-aside />
      <el-container class="flex-center layout-backtop">
        <layout-header v-if="isFixedHeader" />
        <el-scrollbar>
          <layout-header v-if="!isFixedHeader" />
          <layout-main />
        </el-scrollbar>
      </el-container>
    </div>
    <el-backtop target=".layout-backtop .el-scrollbar__wrap" />
  </el-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import ColumnsAside from '../component/ColumnsAside.vue';
import LayoutAside from '../component/Aside.vue';
import LayoutHeader from '../component/Header.vue';
import LayoutMain from '../component/Main.vue';

const themeStore = useCrmebThemeConfigStore();
const isFixedHeader = computed(() => themeStore.themeConfig.isFixedHeader);
</script>
